

import './confirmed-form';
import './need-more-form';
import './unconfirmed-form';

import './appointment-add-workflow.controller.js';
import './appointment-add.controller.js';
import './appointment-add.factory.js';
import './appointment-add.controller.js';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  // Add an appointment base
  .state('inkfinder.appointments.add', {
    url: '/add',
    abstract: true,
    views: {
      '@': {
        template: require('./template.base.html'),
        controller: 'AppointmentAddWorkflowController as $ctrl'
      }
    }
  })

  // Add an appointment: Collector search
  .state('inkfinder.appointments.add.collector', {
    url: '/search-collector',
    template: require('./collector-search-add.html'),
    resolve: {
      $title: function() {
        return 'Add an appointment';
      }
    }
  })

  // Add an appointment: Select a collector
  .state('inkfinder.appointments.add.collector-select', {
    url: '/select',
    template: require('./collector-select.html'),
    resolve: {
      $title: function() {
        return 'Search results';
      }
    }
  })

  // Add an appointment: Add a collector
  .state('inkfinder.appointments.add.collector-create', {
    url: '/create',
    template: require('./collector-create.html'),
    resolve: {
      $title: function() {
        return 'Create an account';
      }
    }
  })

  // Add an appointment: Select a project
  .state('inkfinder.appointments.add.project-select', {
    url: '/project/select',
    template: require('./project-select.html'),
    resolve: {
      $title: function() {
        return 'Select a project';
      }
    }
  })

  // Add an appointment: Add a project
  .state('inkfinder.appointments.add.project-create', {
    url: '/project/create',
    template: require('./project-create.html'),
    resolve: {
      $title: function() {
        return 'Create a new project';
      }
    }
  })

  // Add an appointment: Update the appointment status
  .state('inkfinder.appointments.add.update', {
    url: '/appointment/update',
    template: require('./appointment-update.html'),
    resolve: {
      $title: function() {
        return 'Update the appointment status';
      }
    }
  })

  // Add an appointment: Complete
  .state('inkfinder.appointments.add.complete', {
    url: '/appointment/complete',
    template: require('./appointment-complete.html'),
    resolve: {
      $title: function() {
        return 'Appointment complete';
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/appointments/add/index.js